import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { category } from '../../models/category';
import { environment } from '../../../../environments/environment';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private http: HttpClient) { }

  listCategories() {
    return this.http.get<category[]>(`${environment.apiUrl}/api/category/list`).pipe(take(1));
  }
}
